import { generateEntityCrudActionTypes } from 'syft-acp-util/store/action-types'

const managerCommissions = generateEntityCrudActionTypes('managerCommissions')

export default { ...managerCommissions }
